import Slider from 'react-slick';

import slider_settings from '../../static/slider_settings';

import static_content from '../../static/content';

import './brands.scss';

const Brands = () => (
  <section className="brands">
    <div className="container">
      <h2 className="section-title">We Fix All Makes & Models</h2>

      <Slider {...slider_settings(3, true)} className="brands__list">
        {static_content.brands?.map((el, index) => (
          <SliderCard data={el} key={index} />
        ))}
      </Slider>
    </div>
  </section>
);

export default Brands;

const SliderCard = ({ data }) => (
  <div className="brands__list--item">
    {data.map((el, index) => (
      <div key={index}>
        <img src={el} alt={`slide ${index}`} />
      </div>
    ))}
  </div>
);
